import { InstructionDateInput } from 'components/Form'
import { useHandleEscapeKey } from 'hooks'
import { useUpdate } from 'hooks/userHooks'
import { useEffect, useState } from 'react'
import { Box } from 'theme-ui'
import { UserType } from 'types'

export const PreUnlockModal = ({
  values,
  isCustomerSupportUser,
  interceptConfirm,
  continueConfirm,
  abortConfirm,
  cancel,
}: {
  values: {
    instructionDate: string | undefined
    countryCode: string | undefined
    teachingOrg?: string
    userType?: UserType
    id: string
  }
  isCustomerSupportUser?: boolean
  interceptConfirm: (callback: () => void) => void
  continueConfirm: () => void
  abortConfirm: (error: string) => void
  cancel: () => void
}) => {
  useHandleEscapeKey(cancel)

  const [state, update] = useUpdate()

  const [instructionDate, setInstructionDate] = useState<string | undefined>(
    values.instructionDate
  )

  useEffect(() => {
    if (state.matches('failed')) {
      abortConfirm('Failed to update instruction date, try reloading the page')
    }
    if (state.matches('success')) {
      continueConfirm()
    }
  }, [state, state.value, continueConfirm, abortConfirm])

  //in case changes come down from above, keep it up to date with the parent
  useEffect(() => {
    setInstructionDate(values.instructionDate)
  }, [values.instructionDate, setInstructionDate])

  //code that runs when the submit button is pressed
  useEffect(() => {
    interceptConfirm(() => {
      if (instructionDate !== values.instructionDate) {
        update({
          instructionDate: instructionDate,
          id: values.id,
        })
      } else {
        continueConfirm()
      }
    })
  }, [
    instructionDate,
    values.id,
    values.instructionDate,
    update,
    continueConfirm,
    interceptConfirm,
  ])

  return (
    <div style={{ maxWidth: '420px', textAlign: 'justify', lineHeight: 1.6 }}>
      <Box sx={{ fontWeight: 600, fontSize: '18px', mb: 30 }}>
        The instruction date of your student is:
      </Box>
      <Box sx={{ ml: -1, maxWidth: '350px' }}>
        <InstructionDateInput
          disabled={false}
          currDate={instructionDate}
          onDateChange={(date: string) => {
            setInstructionDate(date)
          }}
          countryCode={values.countryCode}
          teachingOrg={values.teachingOrg}
          userType={values.userType}
          isAdmin={isCustomerSupportUser}
        />
      </Box>
      <Box sx={{ ...labelStyles, mt: '4px' }}>(click on the date to edit)</Box>
      <Box sx={{ ...labelStyles }}>
        {values.userType === 'StudentDC'
          ? 'Make sure the above instruction date is correct, as your student will get access to the Digital Course for 15 days, counting from the instruction date.'
          : 'Make sure the above instruction date is correct, as your student will get access to the Community app 5 days after the instruction date.'}
      </Box>
    </div>
  )
}

const labelStyles = {
  color: '#727B89',
  fontWeight: 400,
}
